module.exports = __webpack_public_path__ + "static/media/home.74bccfa6.mp4";